import service from "./service"

import submitPreCheckConsent from "../submit-pre-check-consent"

const startPreCheckSession = async (data) => {
    await submitPreCheckConsent(data)
    return service(data)
}

export default startPreCheckSession
